import { Phone, Mail, Instagram } from "lucide-react";
import { COMPANY, buildWhatsAppUrl } from "../lib/constants";
import { WhatsAppIcon } from "./sections/Header";

const ACTIONS = [
  {
    id: "phone",
    icon: Phone,
    label: COMPANY.phone,
    href: `tel:${COMPANY.phoneRaw}`,
    cls: "bg-white text-black border border-black/10 hover:bg-black hover:text-white",
  },
  {
    id: "mail",
    icon: Mail,
    label: COMPANY.email,
    href: `mailto:${COMPANY.email}?subject=Anfrage%20Bremer%20Recycling%20Service`,
    cls: "bg-white text-black border border-black/10 hover:bg-black hover:text-white",
  },
  {
    id: "instagram",
    icon: Instagram,
    label: "Instagram · " + COMPANY.instagramHandle,
    href: COMPANY.instagram,
    isExternal: true,
    cls: "bg-white text-black border border-black/10 hover:text-white hover:border-transparent hover:bg-gradient-to-tr hover:from-[#feda75] hover:via-[#d62976] hover:to-[#4f5bd5]",
  },
  {
    id: "wa",
    icon: null,
    label: "WhatsApp · Chat starten",
    href: buildWhatsAppUrl(),
    isWA: true,
    isExternal: true,
    cls: "bg-[#25D366] text-black hover:bg-black hover:text-[#25D366]",
  },
];

export const SideActions = () => {
  return (
    <div
      data-testid="side-actions"
      className="hidden md:flex fixed top-1/2 -translate-y-1/2 right-3 lg:right-5 z-40 flex-col gap-3"
    >
      {ACTIONS.map((a) => (
        <a
          key={a.id}
          href={a.href}
          target={a.isExternal ? "_blank" : undefined}
          rel={a.isExternal ? "noreferrer" : undefined}
          data-testid={`side-action-${a.id}`}
          aria-label={a.label}
          className={`group relative flex items-center justify-end h-12 w-12 hover:w-auto pl-4 pr-4 rounded-full transition-all duration-300 overflow-hidden ${a.cls} ${
            a.isWA ? "shadow-[0_10px_30px_-10px_rgba(37,211,102,0.5)]" : "shadow-[0_10px_30px_-10px_rgba(0,0,0,0.15)]"
          }`}
        >
          <span className="opacity-0 group-hover:opacity-100 transition-opacity max-w-0 group-hover:max-w-xs whitespace-nowrap pr-2 text-xs font-semibold">
            {a.label}
          </span>
          {a.isWA ? (
            <WhatsAppIcon className="w-5 h-5 shrink-0" />
          ) : (
            <a.icon className="w-5 h-5 shrink-0" />
          )}
        </a>
      ))}
    </div>
  );
};
